import { useCallback } from 'react';

/**
 * ActiveFilterBar — displays active filter chips below the controls row.
 * Each chip shows the column name + value(s) and can be individually removed.
 *
 * @param {{
 *   filters: Record<string, string[]>,
 *   columnLabels: Record<string, string>,
 *   onRemoveFilter: (columnKey: string, value: string) => void,
 *   onClearAll: () => void
 * }} props
 */
const ActiveFilterBar = ({ filters, columnLabels, onRemoveFilter, onClearAll }) => {
  const activeEntries = Object.entries(filters).filter(([, vals]) => vals.length > 0);

  const handleRemove = useCallback(
    (key, value) => onRemoveFilter(key, value),
    [onRemoveFilter]
  );

  if (activeEntries.length === 0) return null;

  return (
    <div className="rp-active-filters">
      <span className="rp-active-filters__label">Filters:</span>

      {activeEntries.map(([columnKey, values]) =>
        values.map((value) => (
          <span key={`${columnKey}-${value}`} className="rp-filter-chip">
            <span className="rp-filter-chip__label">{columnLabels[columnKey] || columnKey}:</span>
            <span>{value || '(empty)'}</span>
            <button
              type="button"
              onClick={() => handleRemove(columnKey, value)}
              className="rp-filter-chip__remove"
              aria-label={`Remove filter: ${columnLabels[columnKey] || columnKey} ${value}`}
            >
              <i className="fe fe-x" aria-hidden="true" />
            </button>
          </span>
        ))
      )}

      <button
        type="button"
        onClick={onClearAll}
        className="rp-active-filters__clear"
      >
        Clear All
      </button>
    </div>
  );
};

export default ActiveFilterBar;
